import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
    extraClassName: string;
    messageId: string;
    strongMessageId: string;
};

const DefaultMessage = ({ extraClassName, messageId, strongMessageId }: Props) => {
    return (
        <FormattedMessage
            id={messageId}
            values={{
                extra: '',
                strong: (
                    <StyledDefaultMessage className={extraClassName}>
                        <FormattedMessage id={strongMessageId} />
                    </StyledDefaultMessage>
                ),
            }}
        />
    );
};

export default React.memo<Props>(DefaultMessage);

const StyledDefaultMessage = styled.span`
    font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
    letter-spacing: 1px;
    text-transform: uppercase;
`;
